import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class SpeedLinesView extends AbstractView {
    
    constructor(target) {
        super(target);

        this._target.visible = false;
        this._parts = [this._target.wooshLB, this._target.wooshLF];
    }

    set x(x) {
        this._target.x = x;
    }

    set y(y) {
        this._target.y = y;
    }

    animate(fromX, toX, delay = 0) {
        if (delay >0 ) {
            this.callDelayed(() => {
                this.animate(fromX, toX, 0);
            }, delay);
            return;
        }
        this._target.visible = true;
        this._target.scaleX = fromX > toX ? -1 : 1;
        this.x = toX;
        this._parts.forEach(part => {
            part.gotoAndPlay(0);
        })
    }
}
